import React from "react";
import PropTypes from "prop-types";

// @mui/material components
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const Display = ({ type, open, message, handleClose, icon }) => {
  return (
    <Snackbar open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={handleClose} icon={icon} severity={type} sx={{
        width: "100%",
        maxWidth: "560px",
        borderRadius: ".8rem",
        fontSize: ".8rem",
        lineHeight: 1.5,
        alignItems: "center",
        gap: "12px",
        padding: "8px 16px",
        "& .MuiAlert-icon": {
          padding: 0,
          margin: 0,
          flexShrink: 0,
          alignItems: "center",
        },
        "& .MuiAlert-message": {
          padding: 0,
          minWidth: 0,
          textAlign: "start",
          overflowWrap: "anywhere",
        },
        "& .MuiAlert-action": {
          padding: 0,
          margin: 0,
          marginLeft: "auto",
          flexShrink: 0,
          alignItems: "center",
        },
        "& .MuiAlert-action button": {
          width: "44px",
          height: "44px",
          padding: "8px",
        },
      }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

Display.propTypes = {
  type: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  icon: PropTypes.node
};

export default Display;
